import { render, staticRenderFns } from "./ProductWrhousngRegistration.vue?vue&type=template&id=6e98b10f&scoped=true&"
import script from "./ProductWrhousngRegistration.vue?vue&type=script&lang=js&"
export * from "./ProductWrhousngRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ProductWrhousngRegistration.vue?vue&type=style&index=0&id=6e98b10f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e98b10f",
  null
  
)

export default component.exports